<template>
  <div class="content">
    <div class="section">
      <div class="tag flex-row">
        <div class="flex-column">
          <img src="../../assets/img/btzs-icon.png" />
          <span>团队基础信息</span>
        </div>
      </div>
      <div class="info">
        <div class="title flex-row" v-if="content.stateFlag == 0">
          <img src="../../assets/img/icon-priew.svg" />
          审核中
        </div>
        <div class="title flex-row" v-if="content.stateFlag == 1">
          <img src="../../assets/img/icon-over.svg" />
          <span v-if="content.effectiveStateFlag">完成认证</span>
          <span v-if="!content.effectiveStateFlag">您的账号已到期，请重新填写提交审核</span>
        </div>
        <div
          class="title flex-row"
          style="color: #e34d59; background: #fff8f8"
          v-if="content.stateFlag == 2"
        >
          <img src="../../assets/img/icon-fail.svg" />
          审核未通过 {{ content.remark }}
        </div>
        <div class="table flex-row">
          <div class="left-box">
            <div class="item flex-row">
              <span>团队名称</span>
              <div class="name ellipsis1 flex-row">
                {{ content.teamName }}
                <img
                  src="../../assets/img/icon-choose.svg"
                  v-show="content.stateFlag == 1"
                />
              </div>
            </div>
            <div class="item flex-row">
              <span>经办人员</span>
              <div class="name flex-row">
                {{ content.contact }}
                <img
                  src="../../assets/img/icon-choose.svg"
                  v-show="content.stateFlag == 1"
                />
              </div>
            </div>
            <div class="item flex-row">
              <span>电子邮箱</span>
              <div class="name flex-row">
                {{ content.email }}
                <img
                  src="../../assets/img/icon-choose.svg"
                  v-show="content.stateFlag == 1"
                />
              </div>
            </div>
            <div class="item flex-row">
              <span>有效日期</span>
              <div class="name flex-row">
                {{ content.effectiveStartTime }} - {{ content.effectiveEndTime }}
                <img
                    src="../../assets/img/icon-choose.svg"
                    v-show="content.stateFlag == 1"
                />
              </div>
            </div>
          </div>
          <div class="right-box">
            <div class="item flex-row">
              <span>信用编码</span>
              <div class="name flex-row">
                {{ content.creditCode }}
                <img
                  src="../../assets/img/icon-choose.svg"
                  v-show="content.stateFlag == 1"
                />
              </div>
            </div>
            <div class="item flex-row">
              <span>联系电话</span>
              <div class="name flex-row">
                {{ content.contactNumber }}
                <img
                  src="../../assets/img/icon-choose.svg"
                  v-show="content.stateFlag == 1"
                />
              </div>
            </div>
            <div class="item flex-row">
              <span>联系地址</span>
              <div class="name ellipsis1 flex-row">
                {{ content.address }}
                <img
                  src="../../assets/img/icon-choose.svg"
                  v-show="content.stateFlag == 1"
                />
              </div>
            </div>
            <div class="item flex-row">

            </div>
          </div>
        </div>
      </div>
      <div class="tag flex-row">
        <div class="flex-column">
          <img src="../../assets/img/btzs-icon.png" />
          <span>团队认证文件</span>
        </div>
      </div>
      <div class="fileBox flex-row">
        <div class="item">
          <el-image
            v-if="content.businessLicenseUrl"
            :src="content.businessLicenseUrl"
            fit="cover"
            :preview-src-list="srcList"
          >
          </el-image>
          <div class="pop cursorp">点击查看</div>
          <!-- 	<div class="status" >
						审核中
					</div>
					<div class="status" v-if="false">
						审核通过
					</div>
					<div class="status" style="background:#E34D59;" v-if="false">
						审核不通过
					</div> -->
          统一信用代码照片
        </div>
        <div class="item">
          <el-image
            v-if="content.permitOperation"
            :src="content.permitOperation"
            fit="cover"
            :preview-src-list="srcList"
          >
          </el-image>
          <div class="pop cursorp">点击查看</div>
          <!-- <div class="status" v-if="false">
						审核中
					</div>
					<div class="status" v-if="false">
						审核通过
					</div>
					<div class="status" style="background:#E34D59;">
						审核不通过
					</div> -->
          {{ content.teamType == 0 ? "学校介绍信" : "单位公函" }}
        </div>
      </div>
      <div class="btn cursorp" v-if="false">修改团队信息</div>
      <div class="btn cursorp" @click="confirm">重新提交</div>
    </div>
  </div>
</template>

<script>
import { getTeamAttestationDetail, merchantNo } from "@/utils/http.js";
import tool from "@/utils/tools";
export default {
  name: "Review",
  data() {
    return {
      srcList: [],
      content: {},
    };
  },
  mounted() {
    let uid = tool.getStore("uid");
    // 获取审核详情
    this.getTeamAttestationDetail({
      uid: uid,
    });
  },
  methods: {
    // 获取审核详情
    getTeamAttestationDetail(param) {
      getTeamAttestationDetail(param).then((res) => {
        if (res.code == 0) {
          this.content = res.data;
          this.srcList = [
            this.content.businessLicenseUrl,
            this.content.permitOperation,
          ];
        }

        // 获取缓存中的token
        //  localStorage.setItem("content", JSON.stringify(this.content));
      });
    },
    //点击重新提交
    confirm() {
      this.$router.push({
        name: "TeamInfo",
        params: {
          info: this.content,
          isUpdate: true,
        },
      });
    },
  },
};
</script>

<style scoped>
.content {
  width: 1200px;
  margin: auto;
  background: #fff;
  background-size: 100% 100%;
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.08);
  border-radius: 6px;
  padding: 24px;
  box-sizing: border-box;
}

.section {
  width: 100%;
}

.section .info {
  margin-left: 72px;
  width: 1008px;
  margin-bottom: 24px;
}

.info .title {
  width: 100%;
  height: 40px;
  background: #fcefed;
  border: 1px solid #027A5;
  padding: 0 14px;
  box-sizing: border-box;
  font-size: 16px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 600;
  color: #bb2916;
  margin-bottom: 16px;
}

.info .title img {
  width: 27px;
  height: 27px;
  margin-right: 16px;
}

.info .table {
  width: 100%;
  border: 1px solid #c2c2c2;
}

.info .table .left-box {
  background: #ffffff;
  border-right: 1px solid #c2c2c2;
  flex: 1;
}

.info .table .right-box {
  background: #ffffff;
  flex: 1;
}

.info .item {
  width: 100%;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #c2c2c2;
}

.info .item:last-child {
  border-bottom: none;
}

.info .item span {
  display: block;
  width: 192px;
  height: 100%;
  background: #fafafa;
  text-align: center;
  font-size: 14px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 600;
  color: #000000;
}

.info .item .name {
  width: 311px;
  height: 100%;
  font-size: 14px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #bb2916;
  padding: 0 16px;
  box-sizing: border-box;
  justify-content: space-between;
}

.section .fileBox {
  margin-left: 72px;
  width: 1008px;
  justify-content: space-between;
}

.section .fileBox .item {
  width: 492px;
  border-radius: 6px;
  position: relative;
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
}

.item .pop {
  width: 100%;
  height: 208px;
  position: absolute;
  top: 0;
  right: 0;
  font-size: 14px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  text-align: center;
  background: rgba(0, 0, 0, 0.5);
  line-height: 208px;
  border-radius: 6px;
}

.item .status {
  width: 492px;
  height: 44px;
  background: #bb2916;
  border-radius: 0px 0px 6px 6px;
  text-align: center;
  line-height: 44px;
  font-size: 18px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  margin-top: -2px;
  margin-bottom: 18px;
}

.section .btn {
  width: 324px;
  height: 60px;
  background: #bb2916;
  border-radius: 30px;
  text-align: center;
  line-height: 60px;
  margin: auto;
  font-size: 22px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  margin-top: 26px;
}

/deep/ .item .el-image {
  width: 100%;
  height: 208px;
  z-index: 999;
  /* border-radius: 6px 6px 0 0; */
  border-radius: 6px 6px 6px 6px;
  margin-bottom: 18px;
}
</style>
